import { Stack } from '@mui/material';

import { HelpOutlineIcon, Tooltip, Typography } from '@occc-app/design-system';

import { statusDescription } from '../messaging-campaigns-list.constants';
import { splitTitleAndDescription } from '../messaging-campaigns-list.utils';

export const MessagingCampaignStatusesDescriptionTooltip = () => {
  const titleContent = (
    <Stack gap={0.5}>
      {Object.values(statusDescription).map((item, index) => {
        const { title, description } = splitTitleAndDescription(item);
        return (
          <Typography key={index} variant='body2'>
            <strong>{title}</strong> {description}
          </Typography>
        );
      })}
    </Stack>
  );

  return (
    <Tooltip title={titleContent} placement='top' maxWidth='100%'>
      <HelpOutlineIcon sx={{ height: 16, width: 16, color: 'text.secondary', cursor: 'pointer' }} />
    </Tooltip>
  );
};
